import * as z from "zod/v4";

export const getReturnItemBinLocation = {
  name: "getReturnItemBinLocation" as const,
  input: z.object({ returnId: z.string(), lineItemId: z.string() }),
  output: z.object({ binLocation: z.string().nullish() }),
};

export type GetReturnItemBinLocationOutput = z.infer<
  typeof getReturnItemBinLocation.output
>;
